import { AJOUTE_RESERVATION, SUPRIMER_RESERVATION } from '../types/typeReservation';
const reservation = [];
const ReservationReducer = (state = reservation, action) => {
    if (localStorage.getItem('reservation')) {
        state = JSON.parse(localStorage.getItem('reservation'));
    }
    switch (action.type) {
        case AJOUTE_RESERVATION:
            state = action.payload;
            return state;
            break;
        case SUPRIMER_RESERVATION:
            return state = [];
        default:
            return state;

    }
}

export default ReservationReducer;